/* MUI */
import { Box, Card, CardContent } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/* React */
import React from 'react';
import { useTranslation } from 'react-i18next';

/* Components */
import { KPICard } from '../../internal/KPICard';
import { PercentSubtitle } from './PercentSubtitle';
import {
    StackedKPIsCardContract,
    StackedKPIsCardUsers
} from './StackedKPIsCard';

export const UserDetailsContractDetails = ({ contract }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Box
            className="noBreak"
            data-testid="userDetailsContractDetails"
            display="flex"
            justifyContent="space-between"
            pb="8px"
            px="24px"
            sx={{
                backgroundColor: 'background.contractTable',
                flexFlow: 'wrap'
            }}
            width="100%"
        >
            <Card
                style={{
                    border: 'none',
                    flex: 1,
                    margin: '16px',
                    width: '100%'
                }}
                variant="outlined"
                data-testid="userDetailsContractDetailsUsers"
            >
                <CardContent style={{ height: '100%' }}>
                    <Box
                        display="flex"
                        height="100%"
                        style={{ flexFlow: 'wrap' }}
                    >
                        <Box flex={1}>
                            <KPICard
                                backgroundColor={
                                    theme.palette.background
                                        .reportSummaryCardDark
                                }
                                bigNumber
                                number={contract.users?.length}
                                textColor={
                                    theme.palette.text.reportSummaryCardLight
                                }
                                title={t('Reports.Contracts.usersDetected')}
                            />
                        </Box>
                        <Box flex={1}>
                            <StackedKPIsCardUsers
                                activeUsers={contract.activeUsers}
                                backgroundColor={
                                    theme.palette.background
                                        .contractSummaryCardWhite
                                }
                                subscribedUsers={contract.subscribedUsers}
                                textColor={
                                    theme.palette.text.reportSummaryCardDark
                                }
                            />
                        </Box>
                    </Box>
                </CardContent>
            </Card>
            <Card
                style={{
                    border: 'none',
                    flex: 1,
                    margin: '16px'
                }}
                variant="outlined"
                data-testid="userDetailsContractDetailsContract"
            >
                <CardContent style={{ height: '100%' }}>
                    <Box
                        display="flex"
                        height="100%"
                        style={{ flexFlow: 'wrap' }}
                    >
                        <Box flex={1}>
                            <KPICard
                                backgroundColor={
                                    theme.palette.background
                                        .reportSummaryCardDark
                                }
                                number={contract.mrr}
                                title={t('Reports.Contracts.totalMonthlyValue')}
                                numberIsCurrency
                                textColor={
                                    theme.palette.text.reportSummaryCardLight
                                }
                                subtitle={
                                    <PercentSubtitle
                                        color={
                                            theme.palette.text
                                                .reportSummaryCardLight
                                        }
                                        percentOfTotalMonthlyValue={
                                            contract.percentOfTotalMonthlyValue
                                        }
                                    />
                                }
                            />
                        </Box>
                        <Box flex={1}>
                            <StackedKPIsCardContract
                                backgroundColor={
                                    theme.palette.background
                                        .contractSummaryCardWhite
                                }
                                contract={contract}
                                textColor={
                                    theme.palette.text.reportSummaryCardDark
                                }
                            />
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};
